import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import {
    SelectComponent,
    OptionComponent,
    IconComponent,
    ButtonComponent,
    TooltipDirective
} from '@epd/pattern-library';

import { DiscoveryOption } from '../../../interfaces/dropdown.interface';
import { LeftNavigationService } from '../../services/left-navigation/left-navigation.service';
import { ChatSessionHistoryComponent } from '../chat-session-history/chat-session-history.component';

@Component({
    selector: 'craig-left-navigation',
    standalone: true,
    imports: [
        SelectComponent,
        OptionComponent,
        IconComponent,
        NgClass,
        ButtonComponent,
        TooltipDirective,
        ChatSessionHistoryComponent
    ],
    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftNavigationComponent implements AfterViewInit {
    @ViewChild('dropdownComponent', { static: true }) discoveryDropdown!: SelectComponent;

    isDiscoveryDropdownOpened: boolean = false;

    discoveryOptions: DiscoveryOption[] = [
        { id: '1', label: 'Part Analysis/Comparison (Coming Soon)' },
        { id: '2', label: 'Alternates (Coming Soon)' },
        { id: '3', label: 'Environmental/Compliance (Coming Soon)' },
        { id: '4', label: 'Substance (Coming Soon)' },
        { id: '5', label: 'Pricing and Availability (Coming Soon)' }
    ];

    constructor(
        private readonly leftNavigationService: LeftNavigationService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly _window: Window
    ) {}

    ngAfterViewInit(): void {
        // this.discoveryDropdown.selectComponent.nzOpenChange.subscribe((isOpen: boolean) => {
        //     this._window.setTimeout(() => {
        //         this.isDiscoveryDropdownOpened = isOpen;
        //         this.changeDetectorRef.detectChanges();
        //     });
        // });
    }

    startNewChat(): void {
        this.leftNavigationService.showChat();
    }

    onDiscoveryDropdownClick(event: Event): void {
        event.stopPropagation();

        if (!this.isDiscoveryDropdownOpened) {
            this.discoveryDropdown.selectComponent.setOpenState(true);
        }
    }

    showIntroductionPanel(): void {
        this.leftNavigationService.hideChat();
    }

    provideCraigFeedback(): void {
        this._window.open('https://forms.office.com/r/zd3LWvm43p', '_blank');
    }

    goToDemo(): void {
        this._window.open('https://demo.accuristech.com/share/x1918fnh9twx', '_blank');
    }
}
